import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const StoreContext = createContext(null);

export const StoreProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    storeName: "17/11 BeautyBarn",
    whatsapp: "2348087798684",
    phone: "08087798684",
    location: "Port Harcourt, Nigeria",
  });
  const [config, setConfig] = useState({ paystackEnabled: false, paystackPublicKey: "" });

  useEffect(() => {
    api.get("/settings").then((r) => setSettings((s) => ({ ...s, ...r.data }))).catch(() => {});
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  return <StoreContext.Provider value={{ settings, config }}>{children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
